import React from 'react';
import PropTypes from 'prop-types';
import { Spinner } from 'shared-components/decorators/spinner';
import { FormattedMessage, defineMessages, injectIntl, intlShape } from 'react-intl';
// import moment from 'moment';
import moment from 'moment/min/moment-with-locales';
import { get } from 'lodash';

export const SyncStatusFn = (syncData, disconnectSyncFn, startSyncFn, refreshSyncFn, continueSyncFn, intl) => {
  const translationMessage = defineMessages({
    statusConnected: {
      id: 'hosting.sync_status_hoc.connected',
      defaultMessage: 'Connected'
    },
    ctaRefreshSync: {
      id: 'hosting.sync_status_hoc.refresh_sync',
      defaultMessage: 'Refresh Sync'
    },
    statusDisconnect: {
      id: 'hosting.sync_status_hoc.disconnect',
      defaultMessage: 'Disconnect'
    },
    statusNotConnected: {
      id: 'hosting.sync_status_hoc.not_connected',
      defaultMessage: 'Not connected'
    },
    ctaSyncNow: {
      id: 'hosting.sync_status_hoc.sync_now',
      defaultMessage: 'Sync Now'
    },
    statusInProgress: {
      id: 'hosting.sync_status_hoc.in_progress',
      defaultMessage: 'In progress'
    },
    ctaSyncing: {
      id: 'hosting.sync_status_hoc.syncing',
      defaultMessage: 'Syncing'
    },
    statusInComplete: {
      id: 'hosting.sync_status_hoc.in_complete',
      defaultMessage: 'Incomplete'
    },
    ctaContinueSync: {
      id: 'hosting.sync_status_hoc.continue_sync',
      defaultMessage: 'Continue Sync'
    },
    statusError: {
      id: 'hosting.sync_status_hoc.connection_error',
      defaultMessage: 'Connection error'
    },
    ctaSyncAgain: {
      id: 'hosting.sync_status_hoc.try_again',
      defaultMessage: 'Try again'
    },
    errorMessage: {
      id: 'hosting.sync_status_hoc.error_message',
      defaultMessage: 'Something happened. Please try again later.'
    }
  });

  const syncDisplayData = {
    CONNECTED: {
      status: {
        title: <FormattedMessage
          id="hosting.sync_status.synced_text"
          defaultMessage="Synced {time}"
          values={{
            time: moment(get(syncData, 'calendarData.synced_last')).locale(intl.locale).fromNow()
          }}
        />,
        color: 'text-green'
      },
      cta: {
        title: <FormattedMessage {...translationMessage.ctaRefreshSync} />,
        action: refreshSyncFn
      },
      secondaryBtn: {
        title: <FormattedMessage {...translationMessage.statusDisconnect} />,
        action: disconnectSyncFn
      }
    },
    NOT_CONNECTED: {
      status: {
        title: <FormattedMessage {...translationMessage.statusNotConnected} />,
        color: 'text-gray-dark'
      },
      cta: {
        title: <FormattedMessage {...translationMessage.ctaSyncNow} />,
        action: startSyncFn
      }
    },
    SYNCING: {
      status: {
        title: <FormattedMessage {...translationMessage.statusInProgress} />,
        color: 'text-yellow'
      },
      cta: {
        title: <FormattedMessage {...translationMessage.statusDisconnect} />,
        action: disconnectSyncFn
      }
    },
    AUTHORIZED: {
      status: {
        title: <FormattedMessage {...translationMessage.statusInComplete} />,
        color: 'text-yellow'
      },
      cta: {
        title: <FormattedMessage {...translationMessage.ctaContinueSync} />,
        action: continueSyncFn
      },
      secondaryBtn: {
        title: <FormattedMessage {...translationMessage.statusDisconnect} />,
        action: disconnectSyncFn
      }
    },
    SYNC_ERROR: {
      status: {
        title: <FormattedMessage {...translationMessage.statusError} />,
        color: 'text-danger'
      },
      cta: {
        title: <FormattedMessage {...translationMessage.ctaSyncAgain} />,
        action: startSyncFn
      },
      secondaryBtn: {
        title: <FormattedMessage {...translationMessage.statusDisconnect} />,
        action: disconnectSyncFn
      }
    }
  };

  const currentStatus = syncDisplayData[syncData.status];

  return Object.keys(currentStatus).map((key) => {
    return {
      header: 'status' === key,
      className: 'status' === key ? 'text-gray-dark margin-md-top' : '',
      title: currentStatus[key].title,
      onClick: currentStatus[key].action
    }
  })
};
